import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { InfluencerReviewRoot, ReviewImage } from './InfluencerReview.styes'
import Image, { StaticImageData } from 'next/image'

type InfluencerReviewProps = {
  name: string
  image: StaticImageData
  headline: string
  content: string
}

export const InfluencerReview = ({ name, image, headline, content }: InfluencerReviewProps) => {
  return (
    <InfluencerReviewRoot>
      <Stack direction="column">
        <Stack gap="2" direction="column">
          <ReviewImage>
            <Image src={image} alt="" />
          </ReviewImage>
          <Text display="block" size="headline" weight="medium" align="center">
            {name}
          </Text>
        </Stack>
        <Text size="h5" weight="medium" align="center">
          {headline}
        </Text>
        <Text>“{content}”</Text>
      </Stack>
    </InfluencerReviewRoot>
  )
}
